export default {
    service: 'unconfigured-sail-observability-srv',
    project: 'sail_core'
};

//# sourceMappingURL=defaultConfig.js.map